import './index.less';
import { IExportPlugin, PluginType } from '@/version-types';
import { InstanceData, InstanceDataType } from '../data';
import { Stage } from './instance';
import stageState from './states/stage-state';

export * from './views/base-layer-view';
export * from './views/stage';
export * from './hooks';
export * from './utils/index';
export * from './type';
export { RenderStageView, PreviewStageView } from '../render';

export const frameworkStagePlugin: IExportPlugin = {
    sort: 0,
    type: PluginType.EXTENSION,
    name: 'framework-stage',
    createState() {
        return [stageState];
    },
};

export function createStage(identity: string) {
    const stage = new Stage(identity);
    InstanceData.setData(identity, InstanceDataType.Stage, stage);
    return stage;
}

export function StageAPI(identity: string) {
    return InstanceData.getData(identity, InstanceDataType.Stage) as Stage;
}

export type IStage = ReturnType<typeof StageAPI>;
